<template>
  <div>
    <Hero :title="moduleData.title" />
    <PressContent :content="articleContent" />
  </div>
</template>

<script>
import { Hero, PressContent } from './components'

export default {
  name: 'PressArticleModule',

  components: {
    Hero,
    PressContent,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    articleContent() {
      const data = this.moduleData
      return {
        article: {
          image: data.article_illustration,
          intro: data.article_introduction,
          summary: data.article_summary,
          ctaText: data.article_link_text,
          ctaLink: data.article_link,
        },
        sidebar: {
          logo: data.news_logo,
          date: data.date,
          title: data.article_title,
        },
      }
    },
  },
}
</script>

<style lang="scss" module></style>
